var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('agency-profile-projects',{attrs:{"agency-id":_vm.agencyId}}),_c('agency-users',{attrs:{"agency-id":_vm.agencyId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }